import { useEffect, useState } from 'react';
import { ActionButton } from '../../components/vertical-dot/popper';

export const SharePoolManagementHeader = ({
  actions,
  tableActions,
  resetMousePosition,
}: {
  actions: any;
  tableActions: any;
  hasMousePosition: boolean;
  resetMousePosition: () => void;
}): any[] => {
  useEffect(() => {
    function handleClickOutside(event: any): void {
      if (!(event.target as HTMLElement).className.includes('pop-overs')) {
        resetMousePosition();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [resetMousePosition]);

  const getActions = (rowData: Record<string, any>): any => {
    let newActions = [];
    if (rowData?.vestingType === 'Custom Vesting Tranche') {
      newActions = tableActions.filter((item: any) => !['Preview'].includes(item.action));
    } else {
      newActions = tableActions;
    }
    return newActions;
  };

  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={getActions(row?.original)}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
};
